__turbopack_context__.v({
  "captionDarkMode": "styles-module-scss-module__7Zky0W__captionDarkMode",
  "gameDialogCaption": "styles-module-scss-module__7Zky0W__gameDialogCaption",
  "gameDialogDescription": "styles-module-scss-module__7Zky0W__gameDialogDescription",
  "gameLandingCaption": "styles-module-scss-module__7Zky0W__gameLandingCaption",
  "gameLandingDescription": "styles-module-scss-module__7Zky0W__gameLandingDescription",
});
